<div class="notification-tab">

    <div class="notifications-title">Notifications</div>
    <div class="notifications-subtitle">Choose how you want to receive notifications from SmartProperty.</div>

    <dx-tab-panel id="notifications-sub-menu" [deferRendering]="false" [swipeEnabled]="false" [tabsPosition]="'left'">
        <dxi-tab-panel-item title="Channels">
            <div *dxTemplate>
                <div>
                    <sp-user-settings-notification-channels
                        [userPreferences]="userPreferences$ | async"
                        (updatePreferences)="onUpdatePreferences($event)">
                    </sp-user-settings-notification-channels>
                </div>
            </div>
        </dxi-tab-panel-item>
    
        <dxi-tab-panel-item title="Maintenance">
            <div *dxTemplate>
                <div>
                    <sp-user-settings-notification-tasks
                        [userPreferences]="userPreferences$ | async"
                        (updatePreferences)="onUpdatePreferences($event)">
                    </sp-user-settings-notification-tasks>
                </div>
            </div>
        </dxi-tab-panel-item>
       
        <dxi-tab-panel-item title="Accounts">
            <div *dxTemplate>
                <div>
                    <sp-user-settings-notification-account
                        [userPreferences]="userPreferences$ | async"
                        (updatePreferences)="onUpdatePreferences($event)">
                    </sp-user-settings-notification-account>
                </div>
            </div>
        </dxi-tab-panel-item>

        <dxi-tab-panel-item title="Projects">
            <div *dxTemplate>
                <div>
                    <sp-user-settings-notification-projects
                        [userPreferences]="userPreferences$ | async"
                        (updatePreferences)="onUpdatePreferences($event)">
                    </sp-user-settings-notification-projects>                        
                </div>
            </div>
        </dxi-tab-panel-item>
    </dx-tab-panel>

</div>